import { render } from "./project_detail.vue?vue&type=template&id=ab908e76&scoped=true"
import script from "./project_detail.vue?vue&type=script&lang=js"
export * from "./project_detail.vue?vue&type=script&lang=js"

import "./project_detail.vue?vue&type=style&index=0&id=ab908e76&scoped=true&lang=css"

import exportComponent from "E:\\daxiang\\code\\dx_project_vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab908e76"]])

export default __exports__